export enum SquirrelProviderType
{
    ChatGPT = "ChatGPT",
    Copilot = "Copilot",
    Gemini = "Gemini",
    Claude = "Claude",
    Perplexity = "Perplexity",
    MetaAI = "MetaAI",
    DeepSeek = "DeepSeek",
    Qwen = "Qwen",
    Grok = "Grok",
    Mistral = "Mistral",
}